import { AuthActionsTypes } from "./authActionsTypes";

const AuthActions = {
  //3
  setLogin: (data) => ({
    type: AuthActionsTypes.SET_LOGIN,
    payload: { data },
  }),

  setLoadStore: (data) => ({
    type: AuthActionsTypes.SET_LOAD_STORE,
    payload: { data },
  }),
  logout: (data) => ({
    type: AuthActionsTypes.SET_LOAD_STORE,
  }),
  setError: (data) => ({
    type: AuthActionsTypes.SET_ERROR_LOGIN_STORE,
    payload: { data },
  }),
  setLoadError: (data) => ({
    type: AuthActionsTypes.SET_ERROR_REGISTER,
    payload: { data },
  }),
  setInstagramAuth: (data) => ({
    type: AuthActionsTypes.SET_INSTAGRAM_AUTH,
    payload: { data },
  }),
  updateInstagramAuth: (isAuthenticated) => ({
    type: AuthActionsTypes.UPDATE_INSTAGRAM_AUTH,
    payload: isAuthenticated,
  }),
};

export default AuthActions;
